import { render, staticRenderFns } from "./Autorizacao.vue?vue&type=template&id=79ad05e5&scoped=true"
import script from "./Autorizacao.vue?vue&type=script&lang=js"
export * from "./Autorizacao.vue?vue&type=script&lang=js"
import style0 from "./Autorizacao.vue?vue&type=style&index=0&id=79ad05e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad05e5",
  null
  
)

export default component.exports